import PopupMessage from "App/popupMessage";
import { APP_DRAWER_ELEMENT_ID, APP_HEADER_ELEMENT_ID } from "Common/componentUtils/constants";
import { routesAndPagesMap } from "Common/routingUtils";
import ProgressOverlay from "Components/progressOverlay";
import { themeVariables } from "Components/theme";
import Drawer from "devextreme-react/drawer";
import isEmpty from "lodash/isEmpty";
import join from "lodash/join";
import React, { useEffect, useMemo, useRef } from "react";
import Styled from "./appPage.styled";
import Profile from "./profile";
import Settings from "./settings";
import removeInitLoader from "Common/loader/removeInitLoader";
import styles from "./appPage.module.css";
import { documentWithFloatSidebar } from "Areas/Sidebar/switcher/switcher";
const drawerElementAttrs = { id: APP_DRAWER_ELEMENT_ID };
const handlePreventEvent = (e) => {
    e.preventDefault();
};
const isFloat = (documentType) => documentType && documentWithFloatSidebar.includes(documentType);
export default function AppPage(props) {
    const drawerRef = useRef(null);
    const isFloatSidebar = useMemo(() => isFloat(props.documentType), [props.documentType]);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    const title = useMemo(() => (props.routingPage ? routesAndPagesMap.getLocale(props.routingPage) : "") || "", [props.routingPage]);
    useEffect(() => {
        document.title = title;
    }, [title]);
    if (!isEmpty(props.errors)) {
        throw new Error(join(props.errors, "; "));
    }
    const pageHeader = useMemo(() => (React.createElement(Styled.PageHeader, { sidebarWidth: props.sidebarWidth, id: APP_HEADER_ELEMENT_ID },
        props.header,
        React.createElement(Styled.PageHeaderUser, null,
            React.createElement(Profile, { zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) }),
            React.createElement(Styled.PageHeaderUserName, null, props.user.FullName ? props.user.FullName : null)),
        React.createElement(Settings, { zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) }))), [props.header, props.sidebarWidth, props.user.FullName]);
    const menu = useMemo(() => (React.createElement(ProgressOverlay, { onContextMenu: handlePreventEvent, show: props.inProgress, ignoreParentOverlayInProgress: true, useDots: false }, React.cloneElement(props.sideBar, {
        width: props.sidebarWidth,
        defaultHash: props.defaultHash,
        productName: props.productName,
        header: () => pageHeader
    }))), [
        props.inProgress,
        props.sidebarWidth,
        props.sideBar,
        props.defaultHash,
        props.productName,
        props.user.FullName
    ]);
    useEffect(() => {
        removeInitLoader();
    }, []);
    return (React.createElement(ProgressOverlay, { className: props.className, show: props.inProgress },
        React.createElement(Styled.PageContainer, { sidebarWidth: isFloatSidebar ? 0 : props.sidebarWidth },
            React.createElement(PopupMessage, null),
            React.createElement(Drawer, { elementAttr: drawerElementAttrs, className: styles.drawer, ref: drawerRef, opened: true, openedStateMode: isFloatSidebar ? "overlap" : "shrink", position: "left", revealMode: "expand", animationEnabled: false, maxSize: isFloatSidebar ? 300 : props.sidebarWidth, render: () => menu, closeOnOutsideClick: false, height: "100%" },
                React.createElement(Styled.PageContentInner, null, props.body)))));
}
AppPage.defaultProps = {
    sidebarWidth: 200
};
